var map = {
	"./tasks/setup/competitors/routes.children.js": 9859,
	"./tasks/setup/crop-features/routes.children.js": 6344,
	"./tasks/setup/crop-groups/routes.children.js": 8283,
	"./tasks/setup/crop-types/routes.children.js": 9511,
	"./tasks/setup/crops/routes.children.js": 5408,
	"./tasks/setup/principals/routes.children.js": 6605,
	"./tasks/setup/trial-stations/routes.children.js": 4688,
	"./tasks/setup/varieties/routes.children.js": 493,
	"./tasks/system/configurations/routes.children.js": 9600,
	"./tasks/system/module-tasks/routes.children.js": 689,
	"./tasks/system/user-groups/routes.children.js": 6228,
	"./tasks/system/user-types/routes.children.js": 5860,
	"./tasks/users/routes.children.js": 7098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9196;